var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWho5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 362.667C197.12 362.667 149.333 314.88 149.333 256C149.333 197.12 197.12 149.333 256 149.333C314.88 149.333 362.667 197.12 362.667 256C362.667 314.88 314.88 362.667 256 362.667ZM277.333 0H234.667V106.667H277.333V0ZM277.333 405.333H234.667V512H277.333V405.333ZM106.667 234.667H0V277.333H106.667V234.667ZM512 234.667H405.333V277.333H512V234.667ZM452.053 90.0267L421.973 59.9467L346.453 135.467L376.533 165.547L452.053 90.0267ZM165.547 376.747L135.467 346.667L59.9467 422.187L90.0267 452.267L165.547 376.747ZM165.547 135.467L90.0267 59.9467L59.9467 90.0267L135.467 165.547L165.547 135.467ZM452.267 422.187L376.747 346.667L346.667 376.747L422.187 452.267L452.267 422.187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWho5);
export default __webpack_public_path__ + "static/media/WHO5.8beaa6f0a2a5d5fee9d351d37a61ed14.svg";
export { ForwardRef as ReactComponent };